import type { ListingV2Data, ListingV2Payload } from "../ListingPageV2.types";

export function unwrapListingPayload(payload: ListingV2Payload): ListingV2Data {
  if (
    payload &&
    typeof payload === "object" &&
    "data" in payload &&
    payload.data &&
    typeof payload.data === "object"
  ) {
    return payload.data as ListingV2Data;
  }
  return payload as ListingV2Data;
}
